import React, { useState,useEffect } from "react";
import "./ManageStages.scss";
import PlusIcon from "../../assets/icons/PlusIcon";
import ManageCardWithDetails from "./ManageCardWithDetails";
import PopInWindow from "../popInWindow/PopInWindow";
import CreateStage from "./CreateStage";
import masterApi from "../../services/masterApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
import Loader from "../../components/loader/Loader";

const ManageStages = () => {
    const [ShowPopin, setShowPopin] = useState(false);
    const [stages, setItems] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [reset, setReset] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility
    const [loading, setLoading] = useState(true);
    const handleReset = () => {
        setReset((prev) => !prev);
        fetchData();
      };
  const openPopin = () => {
    setShowPopin(!ShowPopin);
    if (ShowPopin === true) {
        setEditingRow(null);
      }
  };  
  const STAGE_DELETE_SUCCESS_MESSAGE = process.env.REACT_APP_STAGE_DELETE_SUCCESS_MESSAGE
  const STAGE_DELETE_ERROR_MESSAGE = process.env.REACT_APP_STAGE_DELETE_ERROR_MESSAGE
  const fetchData = async () => {
    try {  
          
      const response = await masterApi.getAllStages()      
      let stageList=response?.data?.stageList1;
      setItems(stageList); 
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {    
    fetchData(); 
    setLoading(false);
  },[]);
  const handleEditClick = (row) => {
    openPopin();
    setEditingRow(row);
  };
  const handleDeleteClick = async(row) => {
    setShowPopin(false);
    setEditingRow(row);
    setIsModalVisible(true); 
    //setEditingRow(null); 
  };
  const handleDeleteConfirmClick = async() => {
    setLoading(true);
    const stageId = editingRow?._id;
    const response = await masterApi.deleteStage({ stageId });
      if (response?.ok) {//sucessfully added user    
        setLoading(false);
        toast.success(STAGE_DELETE_SUCCESS_MESSAGE, {autoClose: 1000, // 1 seconds
        });      
        setShowPopin(ShowPopin)
        fetchData();
        setIsModalVisible(false);
        setEditingRow(null); 
      } else {
        setLoading(false);
        toast.error(response.response?.data?.message, {
          autoClose: 2000, // 1 seconds
        }); 
      } 
  };
  const closeModal = () => {
    setIsModalVisible(false);
    setEditingRow(null);
  };  
  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <div className="manage-stages">
        <div className="tittle-aria">
            <h3>Manage Stages</h3>
            <button className="btn" onClick={openPopin}>
                <PlusIcon/>
            </button>
        </div>
        <div className="row">
            <div className="col-md-6">
            
            {stages?.map((group) => (                               
                 <ManageCardWithDetails stage={group} oneditclick={() => handleEditClick(group) } ondeleteclick={() => handleDeleteClick(group) } />                    
                ))}
                
            </div>
        </div>
        {ShowPopin && (
        <PopInWindow title={"Stage"} closePopin={openPopin}>
          <CreateStage close={openPopin} existingData={editingRow} onSave={handleReset} />
        </PopInWindow>
      )}
      {isModalVisible && (
        <ConfirmationModal
          show={isModalVisible}
          title="Delete Stage"
          message={`Are you sure you want to delete ?`}
          onConfirm={handleDeleteConfirmClick} // Call to confirm deletion
          onCancel={closeModal} // Close modal if canceled
          confirmText="Yes, Delete"
          cancelText="No, Cancel"
        />
      )}
    </div>
    )}
    </>
  );
};

export default ManageStages;
